<template>
  <div role="banner">
    <Header @clientHeight="setClientHeight"
            :locked="locked"
            :user-firstname="firstname"
            :user-lastname="lastname"
            @logout="userStore.logout">
    </Header>
  </div>
</template>

<script setup lang="ts">
import {useHeaderLockPositionStore} from "@/stores/headerLockPosition";
import {Header} from "cdp-fe-commons-layout"
import {computed, onBeforeMount, ref, Ref} from "vue";
import {useUserStore} from "@/stores/user";

const headerLockPosition = useHeaderLockPositionStore();
const locked = headerLockPosition.lockedData as Ref<boolean>;
const userStore = useUserStore();

const userref = ref<IUser>();
const firstname: Ref<string | undefined> = computed(() => userref.value?.firstname);
const lastname: Ref<string | undefined> = computed(() => userref.value?.lastname);

onBeforeMount(() => {
  userStore.getUser().then((userEl: IUser | undefined) => userref.value = userEl);
})

function setClientHeight(height: number) {
  headerLockPosition.setHeight(height);
}
</script>
